const initialState = {
    eventsByGroups: [],
    refDataEventProcess: [],
    refDataEventProcessOrders: [],
    gridOptions: {},
    rowData: [],
    widgetEvent: [],
    triggerEvents: [],
};
export default initialState;
